import { store } from '@/store'
import { NavigationGuardNext, Route } from 'vue-router'
import { getDeepLinkParams } from './router-helpers'

/**
 * Prevent navigation to routes that require a selected tenant
 */
export default (to: Route, from, next: NavigationGuardNext) => {
    //  Create a 'pass' function
    const pass = (why: string): void => {
        store.getters.appDebug && console.log(`GUARD: tenant-guard pass. (${why})`)
        return next()
    }

    //  Create a 'fail' function
    const fail = (why: string): void => {
        store.getters.appDebug && console.log(`GUARD: tenant-guard fail. (${why})`)

        //  Get deep link params (if valid) for redirecting after signin
        const params = getDeepLinkParams(to)

        //  Redirect to memberships with query params
        return next(`/signin/2fa${params}`)
    }

    //  Fetch the current tenant
    const tenant = store.getters.tenant

    //  Fetch the current auth user
    const user = store.getters.user

    //  If no user, fail
    if (!user) return fail('user not found')

    //  If a current tenant exists, pass and continue
    if (tenant) return pass('tenant exists')

    //  Get the number of memberships for our auth user
    const memberships = user.memberships

    //  If the user has 0 memberships, then fail
    if (!memberships || !memberships.length) return fail('user does not belong to any tenants')

    //  Grab our tenant from session storage
    const lastTenant = JSON.parse(sessionStorage.getItem('tenant'))

    //  If our last tenant exists, then our type will be lastTEnant, else, it is 1st membership
    const type = lastTenant ? 'lastTenant' : '1st membership tenant'

    //  Our tenant id will be our last tenant id or the 1st membership
    const tenantId = lastTenant ? lastTenant.id : memberships[0].tenant_id

    //  Else, fetch the storage tenant id
    store.dispatch('tenantGet', tenantId).then(tenant => {

        //  If the tenant does NOT exist, remove tenant from sessionStorage
        if (!tenant) {
            store.commit('tenantSet', null)
            return fail('tenant not found')
        }

        //  Else, tenant was loaded, guard passes
        return pass(`${type} loaded`)
    })
}
